import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import {
  MenuItem,
  Button,
  Grid,
  ListItem,
  Divider,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from '@material-ui/core'

import {
  EditableSelect,
  EditableTextField,
  EditableTextArea,
  EditableReactSelect,
  EditableInput,
  EditableSwitch,
} from '../../components/common/EditableComponents'

import { EditableImageUploader } from '../../components/common/ImageUploader'

import { Formik } from 'formik'
import {
  getListVendors,
  getListChildCategories,
  saveMasterProduct,
  updateChildProduct,
  updateChildProducts,
  removeChildProducts,
  updateSingleMasterProducts,
  saveChildProducts,
  getMasterProduct,
} from '../../actions/masterCatalog'

import { getWeedmapAccount } from '../../actions/integration'

import {
  cannabisTypeOptions,
  productTypes,
  status,
  sellTypes,
  weightPerUnits,
  customWeightPerUnits,
} from '../../utils/common'
import { discountableStatus } from '../../utils/catalog/catalog'
import { uploadAssetAPI } from '../../api/assets'

import { getProduct } from '../../actions/inventory'
import ModalConfirmationRemoveLocation from './ModalConfirmationRemoveLocation'
import { openErrorMessage, openSuccessMessage } from '../../actions/message'
import { isValidString } from '../../utils/string'
import { getShopFlowerTypes } from '../../actions/shop'
let timeout

class FormMasterProduct extends Component {
  constructor(props) {
    super(props)
    this.form = createRef()
    this.createMasterProduct = this.createMasterProduct.bind(this)
    this.registerHandler = this.registerHandler.bind(this)
    this.state = {
      masterCategories: [],
      productImages: [],
      showModalMcImages: null,
      openViewImageModal: null,
      selectedImage: null,
      categories: [],
      flowerTypes: [],
      isLoading: false,
      message: 'Creating Master Product',
      productData: { ...this.props.product },
      showConfirmationModal: false,
      validator: true,
      producerMfgSelected: {},
      selectedWeedMap:
        props.product && props.product.thirdPartyProductId
          ? {
              ...(props.product.wmProductMapping &&
                props.product.wmProductMapping.thirdPartyProduct),
              value: props.product && props.product.thirdPartyProductId,
              label: props.product && props.product.thirdPartyProductName,
            }
          : null,
      defaultValues: {
        active: true,
      },
      producerAddress: {},
    }
  }

  componentDidMount() {
    this.getProductData(this.props.product)
    this.getFlowerTypes()
    this.props.dispatch(getWeedmapAccount())
    this.props.dispatch(getListVendors())
  }

  getProductData = (product) => {
    const { vendors } = this.props.masterCatalogReducer || {}
    const vendorList = vendors || []
    if (product) {
      if (product.children) {
        this.props.dispatch(getMasterProduct(product.id)).then((res) => {
          const vendor = vendorList.find((value) => value.id == res.producerMfg)
          this.setState({
            productData: res,
            producerMfgSelected: vendor,
            productImages: res.assets,
          })
          this.getDefaultValues({ ...product, ...res })
        })
      } else {
        this.props.dispatch(getProduct(product.id)).then((res) => {
          const vendor = vendorList.find((value) => value.id == res.producerMfg)
          this.setState({
            productData: res,
            producerMfgSelected: vendor,
            productImages: res.assets,
          })
          this.getDefaultValues({ ...product, ...res })
        })
      }
    } else {
      this.getDefaultValues(null)
    }
  }

  getFlowerTypes = () => {
    const { product } = this.props

    const shopIdsText = product && product.shopId ? product.shopId : ''
    this.props.dispatch(getShopFlowerTypes(shopIdsText)).then((flowerTypes) => {
      this.setState({
        flowerTypes: flowerTypes || [],
      })
    })
  }

  createMasterProduct = () => {
    this.form.current.handleSubmit()
  }

  handleClose = (update) => {
    this.setState({
      validator: true,
    })
    this.props.handleClose(update)
  }

  openConfirmationModal = (newValues) => {
    this.setState({
      showConfirmationModal: true,
      defaultValues: newValues,
    })
  }

  closeConfirmationModal = () => {
    this.setState({
      showConfirmationModal: false,
    })
  }

  registerHandler = (values) => {
    const { product } = this.props
    const { productData, producerMfgSelected, productImages } = this.state
    const allAddress = producerMfgSelected && this.createAddressList(producerMfgSelected)
    const listOfAllAddresses =
      (allAddress &&
        allAddress.map((item) => ({
          id: item.id,
          obj: { ...item },
          label: this.addressObjectToText(item),
        }))) ||
      []
    const producerAddress =
      listOfAllAddresses.find((address) => address.id == values.producerAddress) || {}

    if (product && !this.props.duplicate) {
      if (product.children) {
        if (
          !values.name ||
          !isValidString(values.name) ||
          !values.masterCategoryId ||
          !values.weightPerUnit ||
          !values.vendorId ||
          !values.shopIds ||
          values.shopIds.length == 0
        ) {
          this.setState({ validator: false })
          return
        }
      } else {
        if (
          !values.name ||
          !isValidString(values.name) ||
          !values.categoryId ||
          !values.weightPerUnit ||
          !values.vendorId
        ) {
          this.setState({ validator: false })
          return
        }
      }
    } else {
      const isWeightPerUnitValid =
        values.unitType == 'units' ||
        values.unitType == 'grams' ||
        values.weightPerUnit == 'CUSTOM_GRAMS'
          ? true
          : values.weightPerUnit != null

      if (
        !isWeightPerUnitValid ||
        !values.name ||
        !isValidString(values.name) ||
        !values.masterCategoryId ||
        !values.vendorId ||
        !values.shopIds ||
        values.shopIds.length == 0
      ) {
        this.setState({ validator: false })
        return
      }
    }

    values.secondaryVendors =
      productData.secondaryVendors != values.secondaryVendors
        ? values.secondaryVendors.map((c) => c.value)
        : values.secondaryVendors
    values.tags = productData.tags != values.tags ? values.tags.map((c) => c.value) : values.tags
    values.assets = productImages || []

    if (!product || this.props.duplicate) {
      const newShops =
        (values.shopIds &&
          values.shopIds.length > 0 &&
          values.shopIds
            .filter(function (e) {
              return e
            })
            .map((s) => s.value || s)) ||
        []

      const fixValues = {
        ...values,
        categoryId: values.masterCategoryId,
        shopIds: newShops,
        producerAddress: producerAddress.obj,
        assets: productImages,
      }
      this.props.dispatch(saveMasterProduct(fixValues)).then((res) => {
        this.props.dispatch(openSuccessMessage('Master Product created'))
        if (newShops.length > 0) {
          let body = {
            masterProductId: res.id,
            stores: newShops,
          }

          this.props
            .dispatch(saveChildProducts(body))
            .then(() => {
              this.props.dispatch(openSuccessMessage('Child products created for ' + res.name))
              //THE CREATION OF CHILDREN IS HANDLED IN THE BACKEND
              timeout = setTimeout(() => {
                this.handleClose(true)
                clearTimeout(timeout)
              }, 3000)
            })
            .catch((err) => {
              this.props.dispatch(openErrorMessage('Child products not created'))
            })
        } else {
          //THE CREATION OF CHILDREN IS HANDLED IN THE BACKEND
          timeout = setTimeout(() => {
            this.handleClose(true)
            clearTimeout(timeout)
          }, 3000)
        }
      })
    } else if (product.children) {
      values.id = product.id
      const selectedShops =
        (values.shopIds && values.shopIds.map((s) => (typeof s === 'string' ? s : s.value))) || []
      const deletedShops = productData.shopIds.filter((pd) => !selectedShops.includes(pd)) || []

      values.shopIds = selectedShops
      if (deletedShops.length > 0) {
        this.openConfirmationModal(values)
        this.setState({
          producerAddress: producerAddress,
        })
      } else {
        this.onContinueRegisterHandler(values, producerAddress)
      }
    } else {
      values.id = product.id
      values.producerAddress = producerAddress.obj
      this.props.dispatch(updateChildProduct(values)).then(() => {
        timeout = setTimeout(() => {
          this.handleClose(true)
          clearTimeout(timeout)
        }, 3000)
      })
    }
  }

  onContinueRegisterHandler = (values, newProducerAddress) => {
    const { productData, producerAddress, productImages } = this.state
    const selectedShops = values.shopIds || []
    const newShops = selectedShops.filter((shopId) => !productData.shopIds.includes(shopId))
    const updatedShops = selectedShops.filter((shopId) => productData.shopIds.includes(shopId))
    const deletedShops = productData.shopIds.filter((pd) => !selectedShops.includes(pd))

    const updateProduct = {
      ...values,
      unitPrice: values.unitPrice == '' ? 0 : values.unitPrice,
      shopIds: selectedShops,
      edit: true,
      producerAddress: newProducerAddress ? newProducerAddress.obj : producerAddress.obj,
      assets: productImages,
    }
    this.props.dispatch(updateSingleMasterProducts(updateProduct)).then(async (res) => {
      if (updatedShops.length > 0) {
        await this.props.dispatch(
          updateChildProducts(
            { ...res, masterCategoryId: productData.masterCategoryId },
            updatedShops,
          ),
        )
      }

      if (newShops.length > 0) {
        let body = {
          masterProductId: res.id,
          stores: newShops,
        }

        await this.props.dispatch(saveChildProducts(body))
      }

      if (deletedShops.length > 0) {
        await this.props.dispatch(removeChildProducts(res, deletedShops))
      }

      timeout = setTimeout(() => {
        this.handleClose(true)
        clearTimeout(timeout)
      }, 3000)
    })
  }

  handleChangeMasterCategory = (values, event) => {
    const { product, masterCatalogReducer } = this.props
    var field = product && !product.children ? 'categoryId' : 'masterCategoryId'
    const selectedCategory =
      masterCatalogReducer.categories &&
      masterCatalogReducer.categories.find((cat) => cat.id === event.target.value)
    this.setState({
      defaultValues: {
        ...values,
        [field]: event.target.value,
        unitType: (selectedCategory && selectedCategory.unitType) || '',
        flowerType: selectedCategory && selectedCategory.cannabis ? values.flowerType : '',
      },
    })
  }

  handleChangeLocation = (currentShopIds, setFieldValue, newShopsAux) => {
    const { shops = [] } = this.props
    if (
      currentShopIds &&
      currentShopIds.length &&
      currentShopIds.find((val) => val.label == 'ADD ALL')
    ) {
      let autoSelectedShops = newShopsAux.filter((val) => {
        var auxShop = shops.find((s) => s.id == val.value) || {}
        return val.label != 'ADD ALL' && !auxShop.deleted && auxShop.active
      })
      setFieldValue('shopIds', autoSelectedShops)
    } else {
      setFieldValue('shopIds', currentShopIds)
    }
  }

  getDefaultValues = (product, productData) => {
    let defaultValues
    const { categories = [] } = this.props.masterCatalogReducer

    if (product && !product.children) {
      this.props.dispatch(getListChildCategories(product.shopId)).then((res) => {
        this.setState({
          categories:
            (res &&
              res.values &&
              res.values.map((cat) => ({ id: cat.id, name: cat.name, cannabis: cat.cannabis }))) ||
            [],
        })
      })
    } else {
      this.setState({
        masterCategories: categories.map((cat) => ({
          id: cat.id,
          name: cat.name,
          cannabis: cat.cannabis,
        })),
      })
    }

    if (product) {
      if (product.children && !this.props.duplicate) {
        this.setState({
          defaultValues: {
            ...product,
            categoryId: product.masterCategoryId,
            producerAddress: product.producerAddress && product.producerAddress.id,
            shopIds: product.children.map((child) => child.shopId),
          },
        })
      } else {
        let { name, sku } = product
        if (this.props.duplicate) {
          name = name + ' (Copy)'
          sku = ''
        }
        this.setState({
          defaultValues: {
            ...product,
            name: name,
            sku: sku,
            producerAddress: product.producerAddress && product.producerAddress.id,
          },
        })
      }
    } else {
      defaultValues = {
        name: '',
        categoryId: '',
        masterCategoryId: '',
        vendorId: '',
        sku: '',
        productType: 'REGULAR',
        cannabisType: 'DEFAULT',
        unitPrice: '',
        active: true,
        weightPerUnit: '',
        flowerType: '',
        enableMixMatch: false,
        priceIncludesExcise: false,
        priceIncludesALExcise: false,
        productSaleType: 'Both',
        enableWeedmap: false,
        showInWidget: true,
        potency: false,
        discountable: true,
        discountEnabled: true,
        wmThreshold: 0.0,
        unitType: '',
        pricingTemplateId: '',
        shopIds: [],
        tags: [],
      }
      this.setState({
        defaultValues: { ...defaultValues },
      })
    }
  }

  getTitle = (product) => {
    let title = ''
    if (!product) {
      title = 'Create New Master Product'
    } else if (product.children) {
      if (this.props.duplicate) {
        return "Duplicating '" + product.name + "'"
      }
      title = 'Edit Master Product'
    } else if (product.masterId) {
      title = 'Edit Child Product'
    } else {
      title = 'Edit Orphan Product'
    }
    return title
  }

  addressObjectToText(address) {
    if (!address) {
      return null
    }
    let tempArray = [
      (address && address.address) || '',
      (address && address.city) || '',
      (address && address.state) || '',
      (address && address.country) || '',
      (address && address.zipCode) || '',
    ]
    return tempArray.filter((element) => element && element.trim()).join(', ') || ''
  }

  createAddressList = (vendor) => {
    let { address = {}, additionalAddressList = [] } = vendor
    let txt1 = this.addressObjectToText(address || {})
    let addresses =
      additionalAddressList && additionalAddressList.length
        ? additionalAddressList.map((i) => {
            let txt2 = this.addressObjectToText(i || {})
            return { ...i, name: txt2 }
          })
        : []
    if (txt1) {
      return [{ ...address, name: `${txt1} (default)` }, ...addresses]
    } else if (addresses.length) {
      return [...addresses]
    }
    return []
  }

  loadProducerMfgSelected = (vendorId) => {
    const { vendors } = this.props.masterCatalogReducer || {}
    const vendorList = vendors || []
    const vendor = vendorList.find((value) => value.id == vendorId)
    this.setState({
      producerMfgSelected: vendor,
    })
  }

  shopEmployeeList = (row) => {
    const { shops } = this.props

    const findShop = shops && shops.find((shop) => shop.id == row)
    return findShop
      ? {
          value: findShop.id,
          label: findShop.name,
        }
      : 'Shop not found'
  }

  onChangeOnlyNumbers = (values, e, field) => {
    const re = /^[0-9]+(\.)?[0-9]*$/ ///^([0-9]+([.][0-9]*)?|[.][0-9]+)$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      this.setState({
        defaultValues: {
          ...values,
          [field]: e.target.value,
        },
      })
    }
  }

  isNALVendor = (vendorsList, vendorId) => {
    const vendor = vendorsList.find((value) => value.id == vendorId)
    if (vendor && vendor.armsLengthType == 'NON_ARMS_LENGTH') {
      return true
    } else {
      return false
    }
  }

  onChangePotencyResults = (key, value, values, setFieldValue) => {
    const re = /^([0-9]+([.][0-9]*)?|[.][0-9]+)$/
    if (!value || re.test(value)) {
      var updatePotency = (values.potencyAmount && { ...values.potencyAmount }) || {}
      updatePotency[key] = value
      setFieldValue('potencyAmount', updatePotency)
    }
  }

  uploadProductImage = (file, type, url) => {
    return new Promise((res, rej) => {
      uploadAssetAPI(file, 'photo/public').then((response) => {
        const { productImages } = this.state
        let newList = productImages
        newList.push(response)
        this.setState({
          productImages: newList,
        })
        res(response)
      })
    })
  }

  closeImageModal = () => {
    this.setState({
      showModalMcImages: false,
    })
  }

  viewImage = (image) => {
    this.setState({
      selectedImage: image.largeX2URL,
      openViewImageModal: true,
    })
  }

  handleCloseViewImage = () => {
    this.setState({
      openViewImageModal: false,
    })
  }
  handleWeightPerUnit = (values, setFieldValue, event) => {
    this.setState({
      defaultValues: {
        ...values,
        customGramType: null,
        customWeight: null,
        weightPerUnit: event.target.value,
      },
    })
  }

  removeImage = (image) => {
    const { productImages } = this.state
    let newList = productImages.filter((c) => c.id !== image.id)
    this.setState({
      productImages: newList,
    })
  }
  showMcImageModal = () => {
    this.setState({
      showModalMcImages: true,
    })
  }

  isCannabis = () => {
    const { defaultValues: values, categories, masterCategories } = this.state

    if (values) {
      if (values.shopId) {
        const category = categories.find((cat) => cat.id == values.categoryId)
        return category && category.cannabis
      } else {
        const masterCategory = masterCategories.find((cat) => cat.id == values.masterCategoryId)
        return masterCategory && masterCategory.cannabis
      }
    }
    return false
  }

  render() {
    const {
      masterCategories,
      categories,
      productData,
      showConfirmationModal,
      validator,
      producerMfgSelected,
      defaultValues,
      flowerTypes,
      productImages,
      showModalMcImages,
      openViewImageModal,
      selectedImage,
    } = this.state
    const { product = null, shops = [], cannabisTypeList, cannabisTypeForState } = this.props
    const { brands, vendors, allProductTags } = this.props.masterCatalogReducer || {}
    const brandList = brands || []
    const vendorList = vendors || []
    let productTagList = Array.from(allProductTags).filter(function (el) {
      return el
    })

    let newShopsAux = []
    if (shops) {
      newShopsAux = shops
        .filter((s) => !s.deleted && s.name)
        .map((shop) => ({
          value: shop.id,
          label: shop.name,
          disabled: !shop.active,
          clearableValue: true,
        }))
      newShopsAux.unshift({ label: 'ADD ALL', value: '0', clearableValue: true })
    }
    const isDistro =
      (defaultValues &&
        defaultValues.shop &&
        defaultValues.shop.appTarget &&
        defaultValues.shop.appTarget == 'Distribution') ||
      !defaultValues.shop
        ? true
        : false
    brandList.sort(function (a, b) {
      if (a.name > b.name) {
        return 1
      }
      if (a.name < b.name) {
        return -1
      }
      return 0
    })
    const allAddress = producerMfgSelected && this.createAddressList(producerMfgSelected)
    const listOfAllAddresses =
      allAddress &&
      allAddress.map((item) => ({
        id: item.id,
        obj: { ...item },
        label: this.addressObjectToText(item),
      }))

    var sourceMap = defaultValues.masterId ? defaultValues.sourceMap || {} : {}
    const ListCannabisTypeOption = cannabisTypeForState ? cannabisTypeList : cannabisTypeOptions

    return (
      <div className="formMasterProduct-Category">
        <h2 className="title-side-bard-form">{this.getTitle(product)}</h2>
        <div className="container-form">
          <Formik
            innerRef={this.form}
            enableReinitialize
            initialValues={{ ...defaultValues }}
            onSubmit={(values, { setSubmitting }) => {
              this.registerHandler(values)
              setSubmitting(false)
            }}
          >
            {(formik) => {
              const { values, handleChange, setFieldValue } = formik
              const isMaster = !product || product.children ? true : false

              return (
                <form onSubmit={formik.handleSubmit}>
                  {isMaster && (
                    <ListItem>
                      <Grid container className="center-aligned-child">
                        <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                          <label className="label-modal">Locations *</label>
                        </Grid>
                        <Grid className="editField" item xs={12} sm={7} md={7} lg={7}>
                          <EditableReactSelect
                            menuContainerStyle={{ zIndex: 5 }}
                            multi={true}
                            material={false}
                            value={values.shopIds}
                            onChange={(value) => {
                              this.handleChangeLocation(value, setFieldValue, newShopsAux)
                            }}
                            valueToRender={values.shopIds}
                            editMode={true}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            options={newShopsAux}
                            placeholder="Search"
                            clearable={true}
                          ></EditableReactSelect>
                          {!validator && (!values.shopIds || values.shopIds.length == 0) && (
                            <span style={{ color: 'red' }}>A location is required</span>
                          )}
                        </Grid>
                      </Grid>
                    </ListItem>
                  )}
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">Product Type</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableSelect
                          editMode={true}
                          material={false}
                          name="productType"
                          value={values.productType || ''}
                          onChange={handleChange}
                          valueToRender={values.productType || ''}
                          disabled={sourceMap.productType == 'PARENT'}
                        >
                          {productTypes.map((item, index) => {
                            return (
                              <MenuItem key={index} value={item.value}>
                                {item.label}
                              </MenuItem>
                            )
                          })}
                        </EditableSelect>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">Product Name*</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableTextField
                          name="name"
                          placeholder={'Enter Name'}
                          editMode={true}
                          material={false}
                          value={values.name || ''}
                          onChange={handleChange}
                          valueToRender={values.name || ''}
                          disabled={product && product.masterId}
                        />
                        {!validator && !isValidString(values.name) && (
                          <span style={{ color: 'red' }}>Product Name is required</span>
                        )}
                      </Grid>
                    </Grid>
                  </ListItem>

                  {isMaster ? (
                    <ListItem>
                      <Grid container className="center-aligned-child">
                        <Grid className="labelField" item xs={12} sm={5}>
                          <label className="label-modal">Master Categories*</label>
                        </Grid>
                        <Grid item xs={12} sm={7} md={7} lg={7}>
                          <EditableSelect
                            name={!product ? 'categoryId' : 'masterCategoryId'}
                            editMode={true}
                            material={false}
                            value={values.masterCategoryId}
                            onChange={(event) => {
                              this.handleChangeMasterCategory(values, event)
                            }}
                            valueToRender={values.masterCategoryId}
                          >
                            {masterCategories.map((item, index) => {
                              return (
                                <MenuItem key={index} value={item.id}>
                                  {item.name}
                                </MenuItem>
                              )
                            })}
                          </EditableSelect>
                          {!validator && !values.masterCategoryId && (
                            <span style={{ color: 'red' }}>Category is required</span>
                          )}
                        </Grid>
                      </Grid>
                    </ListItem>
                  ) : (
                    <ListItem>
                      <Grid container className="center-aligned-child">
                        <Grid className="labelField" item xs={12} sm={5}>
                          <label className="label-modal">Category *</label>
                        </Grid>
                        <Grid item xs={12} sm={7} md={7} lg={7}>
                          <EditableSelect
                            name="categoryId"
                            editMode={true}
                            material={false}
                            value={values.categoryId}
                            onChange={(event) => this.handleChangeMasterCategory(values, event)}
                            valueToRender={values.categoryId}
                          >
                            {categories.map((item, index) => {
                              return (
                                <MenuItem key={index} value={item.id}>
                                  {item.name}
                                </MenuItem>
                              )
                            })}
                          </EditableSelect>
                          {!validator && !values.categoryId && (
                            <span style={{ color: 'red' }}>Category is required</span>
                          )}
                        </Grid>
                      </Grid>
                    </ListItem>
                  )}
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">Cannabis Type</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableSelect
                          name="cannabisType"
                          editMode={true}
                          material={false}
                          value={values.cannabisType || ''}
                          onChange={handleChange}
                          valueToRender={values.cannabisType || ''}
                        >
                          {Object.keys(ListCannabisTypeOption).map((item, index) => {
                            return (
                              <MenuItem key={item} value={item}>
                                {item == 'DEFAULT'
                                  ? 'Inherit from Category'
                                  : ListCannabisTypeOption[item]}
                              </MenuItem>
                            )
                          })}
                        </EditableSelect>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">Status</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableSwitch
                          id="active"
                          name="active"
                          editMode={true}
                          onChange={(event, value) => {
                            setFieldValue('active', value)
                          }}
                          checked={values.active}
                          disabled={sourceMap.active == 'PARENT'}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>

                  {values.unitType !== 'grams' && (
                    <ListItem>
                      <Grid container className="center-aligned-child">
                        <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                          <label className="label-modal">Weight Per Unit*</label>
                        </Grid>
                        <Grid item xs={12} sm={7} md={7} lg={7}>
                          <EditableSelect
                            name="weightPerUnit"
                            editMode={true}
                            material={false}
                            value={values.weightPerUnit}
                            onChange={(event) =>
                              this.handleWeightPerUnit(values, setFieldValue, event)
                            }
                            valueToRender={values.weightPerUnit}
                          >
                            {weightPerUnits.map((item, index) => {
                              return (
                                <MenuItem key={index} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              )
                            })}
                          </EditableSelect>
                          {!validator && !values.weightPerUnit && (
                            <span style={{ color: 'red' }}>Weight is required</span>
                          )}
                        </Grid>
                      </Grid>
                    </ListItem>
                  )}
                  {values.weightPerUnit == 'CUSTOM_GRAMS' && (
                    <ListItem>
                      <Grid container className="center-aligned-child">
                        <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                          <label className="label-modal">Custom Weight Option</label>
                        </Grid>
                        <Grid item xs={12} sm={7} md={7} lg={7}>
                          <EditableSelect
                            name="customGramType"
                            editMode={true}
                            material={false}
                            value={values.customGramType}
                            onChange={handleChange}
                            valueToRender={values.customGramType}
                          >
                            {customWeightPerUnits.map((item, index) => {
                              return (
                                <MenuItem key={index} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              )
                            })}
                          </EditableSelect>
                        </Grid>
                      </Grid>
                    </ListItem>
                  )}
                  {values.weightPerUnit == 'CUSTOM_GRAMS' && (
                    <ListItem>
                      <Grid container className="center-aligned-child">
                        <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                          <label className="label-modal">Custom Weight Value</label>
                        </Grid>
                        <Grid item xs={12} sm={7} md={7} lg={7}>
                          <EditableInput
                            name="customWeight"
                            editMode={true}
                            material={false}
                            value={values.customWeight}
                            onChange={(event) =>
                              this.onChangeOnlyNumbers(values, event, 'customWeight')
                            }
                            valueToRender={values.customWeight}
                          />
                        </Grid>
                      </Grid>
                    </ListItem>
                  )}

                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">Retail Value</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableInput
                          name="unitPrice"
                          placeholder={'Enter Retail Value'}
                          editMode={true}
                          material={false}
                          value={values.unitPrice}
                          onChange={(event) => this.onChangeOnlyNumbers(values, event, 'unitPrice')}
                          valueToRender={values.unitPrice}
                          disabled={sourceMap.unitPrice == 'PARENT'}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  {this.isCannabis() && (
                    <ListItem>
                      <Grid container className="center-aligned-child">
                        <Grid className="labelField" item xs={12} sm={5}>
                          <label className="label-modal">Flower Type</label>
                        </Grid>
                        <Grid item xs={12} sm={7} md={7} lg={7}>
                          <EditableSelect
                            name="flowerType"
                            editMode
                            material={false}
                            value={values.flowerType}
                            onChange={handleChange}
                          >
                            <MenuItem value="">Select Flower Type</MenuItem>
                            {flowerTypes.map((flowerType) => {
                              return (
                                <MenuItem key={flowerType} value={flowerType}>
                                  {flowerType}
                                </MenuItem>
                              )
                            })}
                          </EditableSelect>
                        </Grid>
                      </Grid>
                    </ListItem>
                  )}
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">SKU</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableTextField
                          name="sku"
                          placeholder={'Enter SKU'}
                          disabled={!!product}
                          editMode={true}
                          material={false}
                          value={values.sku}
                          onChange={handleChange}
                          valueToRender={values.sku}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">Vendor*</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableSelect
                          name="vendorId"
                          editMode={true}
                          material={false}
                          value={values.vendorId}
                          onChange={handleChange}
                          valueToRender={values.vendorId}
                          disabled={sourceMap.vendorId == 'PARENT'}
                        >
                          {(vendorList && vendorList.map
                            ? vendorList.map(
                                (vendor) =>
                                  vendor.active && {
                                    value: vendor.id,
                                    label: vendor.name,
                                    clearableValue: true,
                                  },
                              )
                            : []
                          ).map((item, index) => {
                            return (
                              <MenuItem key={index} value={item.value}>
                                {item.label}
                              </MenuItem>
                            )
                          })}
                        </EditableSelect>
                        {!validator && !values.vendorId && (
                          <span style={{ color: 'red' }}>Vendor is required</span>
                        )}
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">Secondary Vendors</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableReactSelect
                          multi={true}
                          editMode={true}
                          material={false}
                          value={values.secondaryVendors}
                          onChange={(value) => setFieldValue('secondaryVendors', value)}
                          valueToRender={values.secondaryVendors}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          options={
                            vendorList && vendorList.map
                              ? vendorList.map(
                                  (vendor) =>
                                    vendor.active &&
                                    vendor.id !== values.vendorId && {
                                      value: vendor.id,
                                      label: vendor.name,
                                      clearableValue: true,
                                    },
                                )
                              : []
                          }
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">Brand</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableSelect
                          name="brandId"
                          editMode={true}
                          material={false}
                          value={values.brandId}
                          onChange={handleChange}
                          valueToRender={values.brandId}
                        >
                          {(
                            (brandList &&
                              brandList.length &&
                              brandList
                                .filter((brand) => brand.active === true)
                                .map((brand) => ({
                                  value: brand.id,
                                  label: brand.name,
                                }))) ||
                            []
                          ).map((item, index) => {
                            return (
                              <MenuItem key={index} value={item.value}>
                                {item.label}
                              </MenuItem>
                            )
                          })}
                        </EditableSelect>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">Description</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableTextArea
                          name="description"
                          placeholder={'description'}
                          editMode={true}
                          material={false}
                          value={values.description}
                          onChange={handleChange}
                          valueToRender={values.description}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>

                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">Product Tags</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableReactSelect
                          multi={true}
                          editMode={true}
                          material={false}
                          value={values.tags}
                          onChange={(value) => setFieldValue('tags', value)}
                          valueToRender={values.tags}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          options={
                            (productTagList &&
                              productTagList.map(
                                (tag) =>
                                  tag && {
                                    value: tag,
                                    label: tag,
                                    clearableValue: true,
                                  },
                              )) ||
                            []
                          }
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">Sell Type</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableSelect
                          name="productSaleType"
                          editMode={true}
                          material={false}
                          value={values.productSaleType}
                          onChange={handleChange}
                          valueToRender={values.productSaleType}
                        >
                          {sellTypes.map((item, index) => {
                            return (
                              <MenuItem key={index} value={item.value}>
                                {item.label}
                              </MenuItem>
                            )
                          })}
                        </EditableSelect>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">Sync to Third Party Menus</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableSelect
                          name="enableWeedmap"
                          editMode={true}
                          material={false}
                          value={values.enableWeedmap}
                          onChange={handleChange}
                          valueToRender={values.enableWeedmap}
                          disabled={sourceMap.enableWeedmap == 'PARENT'}
                        >
                          {status.map((item, index) => {
                            return (
                              <MenuItem key={index} value={item.value}>
                                {item.label}
                              </MenuItem>
                            )
                          })}
                        </EditableSelect>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">Show In Online Widget</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableSelect
                          name="showInWidget"
                          editMode={true}
                          material={false}
                          value={values.showInWidget}
                          onChange={handleChange}
                          valueToRender={values.showInWidget}
                          disabled={sourceMap.showInWidget == 'PARENT'}
                        >
                          {status.map((item, index) => {
                            return (
                              <MenuItem key={item.value} value={item.value}>
                                {item.label}
                              </MenuItem>
                            )
                          })}
                        </EditableSelect>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">Price Includes Excise Tax</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        {this.isNALVendor(vendorList, values.vendorId) ? (
                          <EditableSelect
                            name="priceIncludesExcise"
                            editMode={true}
                            material={false}
                            value={values.priceIncludesExcise}
                            onChange={handleChange}
                            valueToRender={values.priceIncludesExcise}
                            disabled={sourceMap.priceIncludesExcise == 'PARENT'}
                          >
                            {status.map((item, index) => {
                              return (
                                <MenuItem key={item.value} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              )
                            })}
                          </EditableSelect>
                        ) : (
                          <EditableSelect
                            name="priceIncludesALExcise"
                            editMode={true}
                            material={false}
                            value={values.priceIncludesALExcise}
                            onChange={handleChange}
                            valueToRender={values.priceIncludesALExcise}
                            disabled={sourceMap.priceIncludesExcise == 'PARENT'}
                          >
                            {status.map((item, index) => {
                              return (
                                <MenuItem key={item.value} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              )
                            })}
                          </EditableSelect>
                        )}
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">Same Price Mix & Match</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableSelect
                          name="enableMixMatch"
                          editMode={true}
                          material={false}
                          value={values.enableMixMatch}
                          onChange={handleChange}
                          valueToRender={values.enableMixMatch}
                        >
                          {status.map((item, index) => {
                            return (
                              <MenuItem key={item.value} value={item.value}>
                                {item.label}
                              </MenuItem>
                            )
                          })}
                        </EditableSelect>
                      </Grid>
                    </Grid>
                  </ListItem>

                  {isDistro && <Divider />}
                  {isDistro && (
                    <ListItem>
                      <Grid container className="center-aligned-child">
                        <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                          <label className="label-modal">Producer MFG</label>
                        </Grid>
                        <Grid item xs={12} sm={7} md={7} lg={7}>
                          <EditableSelect
                            name="producerMfg"
                            editMode={true}
                            material={false}
                            value={values.producerMfg}
                            onChange={(e) => {
                              setFieldValue('producerMfg', e.target.value)
                              this.loadProducerMfgSelected(e.target.value)
                            }}
                          >
                            {(vendorList && vendorList.map
                              ? vendorList.map(
                                  (vendor) =>
                                    vendor.active && {
                                      value: vendor.id,
                                      label: vendor.name,
                                      clearableValue: true,
                                    },
                                )
                              : []
                            ).map((item, index) => {
                              return (
                                <MenuItem key={index} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              )
                            })}
                          </EditableSelect>
                        </Grid>
                      </Grid>
                    </ListItem>
                  )}
                  {isDistro && (
                    <ListItem>
                      <Grid container className="center-aligned-child">
                        <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                          <label className="label-modal">Producer License#</label>
                        </Grid>
                        <Grid item xs={12} sm={7} md={7} lg={7}>
                          <EditableSelect
                            name="producerLicense"
                            editMode={true}
                            material={false}
                            value={values.producerLicense}
                            onChange={(e) => {
                              setFieldValue('producerLicense', e.target.value)
                            }}
                          >
                            {producerMfgSelected &&
                              producerMfgSelected.companyLicenses &&
                              producerMfgSelected.companyLicenses.map((item, index) => {
                                return (
                                  <MenuItem key={index} value={item.id}>
                                    {item.licenseNumber}
                                  </MenuItem>
                                )
                              })}
                          </EditableSelect>
                        </Grid>
                      </Grid>
                    </ListItem>
                  )}
                  {isDistro && (
                    <ListItem>
                      <Grid container className="center-aligned-child">
                        <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                          <label className="label-modal">Producer Address</label>
                        </Grid>
                        <Grid item xs={12} sm={7} md={7} lg={7}>
                          <EditableSelect
                            name="producerAddress"
                            editMode={true}
                            material={false}
                            value={values.producerAddress}
                            onChange={(e) => {
                              setFieldValue('producerAddress', e.target.value)
                            }}
                            valueToRender={
                              (listOfAllAddresses &&
                                listOfAllAddresses.find(
                                  (address) => address.id == values.producerAddress,
                                ) &&
                                listOfAllAddresses.find(
                                  (address) => address.id == values.producerAddress,
                                ).label) ||
                              ''
                            }
                          >
                            {listOfAllAddresses &&
                              listOfAllAddresses.map((item, index) => {
                                return (
                                  <MenuItem key={index} value={item.id}>
                                    {item.label}
                                  </MenuItem>
                                )
                              })}
                          </EditableSelect>
                        </Grid>
                      </Grid>
                    </ListItem>
                  )}
                  <Divider />
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12}>
                        <label className="label-modal" style={{ fontSize: '18px' }}>
                          {' '}
                          Potency{' '}
                        </label>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">Show Potency on Web</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableSelect
                          name="potency"
                          editMode={true}
                          material={false}
                          value={values.potency}
                          onChange={handleChange}
                          valueToRender={values.potency}
                        >
                          {status.map((item, index) => {
                            return (
                              <MenuItem key={index} value={item.value}>
                                {item.label}
                              </MenuItem>
                            )
                          })}
                        </EditableSelect>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5}>
                        <label className="label-modal"> Total THC (mg) </label>
                      </Grid>
                      <Grid item xs={12} sm={7}>
                        <EditableInput
                          name="thc"
                          placeholder="0.0%"
                          editMode
                          material={false}
                          value={(values.potencyAmount && values.potencyAmount.thc) || ''}
                          onChange={(event) =>
                            this.onChangePotencyResults(
                              'thc',
                              event.target.value,
                              values,
                              setFieldValue,
                            )
                          }
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5}>
                        <label className="label-modal"> THCa (mg) </label>
                      </Grid>
                      <Grid item xs={12} sm={7}>
                        <EditableInput
                          name="thca"
                          placeholder="0.0%"
                          editMode
                          material={false}
                          value={(values.potencyAmount && values.potencyAmount.thca) || ''}
                          onChange={(event) =>
                            this.onChangePotencyResults(
                              'thca',
                              event.target.value,
                              values,
                              setFieldValue,
                            )
                          }
                          type="number"
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5}>
                        <label className="label-modal"> Total CBD (mg) </label>
                      </Grid>
                      <Grid item xs={12} sm={7}>
                        <EditableInput
                          name="cbd"
                          placeholder="0.0%"
                          editMode
                          material={false}
                          value={(values.potencyAmount && values.potencyAmount.cbd) || ''}
                          onChange={(event) =>
                            this.onChangePotencyResults(
                              'cbd',
                              event.target.value,
                              values,
                              setFieldValue,
                            )
                          }
                          type="number"
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5}>
                        <label className="label-modal"> CBDa (mg) </label>
                      </Grid>
                      <Grid item xs={12} sm={7}>
                        <EditableInput
                          name="cbda"
                          placeholder="0.0%"
                          editMode
                          material={false}
                          value={(values.potencyAmount && values.potencyAmount.cbda) || ''}
                          onChange={(event) =>
                            this.onChangePotencyResults(
                              'cbda',
                              event.target.value,
                              values,
                              setFieldValue,
                            )
                          }
                          type="number"
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5}>
                        <label className="label-modal"> CBN (mg) </label>
                      </Grid>
                      <Grid item xs={12} sm={7}>
                        <EditableInput
                          name="cbn"
                          placeholder="0.0%"
                          editMode
                          material={false}
                          value={(values.potencyAmount && values.potencyAmount.cbn) || ''}
                          onChange={(event) =>
                            this.onChangePotencyResults(
                              'cbn',
                              event.target.value,
                              values,
                              setFieldValue,
                            )
                          }
                          type="number"
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12}>
                        <label className="label-modal" style={{ fontSize: '18px' }}>
                          {' '}
                          Concentration{' '}
                        </label>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5}>
                        <label className="label-modal"> Total THC % </label>
                      </Grid>
                      <Grid item xs={12} sm={7}>
                        <EditableInput
                          name="thc"
                          placeholder="0.0%"
                          editMode
                          material={false}
                          value={values.thc || ''}
                          onChange={handleChange}
                          type="number"
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5}>
                        <label className="label-modal"> THCa % </label>
                      </Grid>
                      <Grid item xs={12} sm={7}>
                        <EditableInput
                          name="thca"
                          placeholder="0.0%"
                          editMode
                          material={false}
                          value={values.thca || ''}
                          onChange={handleChange}
                          type="number"
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5}>
                        <label className="label-modal"> Total CBD % </label>
                      </Grid>
                      <Grid item xs={12} sm={7}>
                        <EditableInput
                          name="cbd"
                          placeholder="0.0%"
                          editMode
                          material={false}
                          value={values.cbd || ''}
                          onChange={handleChange}
                          type="number"
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5}>
                        <label className="label-modal"> CBDa % </label>
                      </Grid>
                      <Grid item xs={12} sm={7}>
                        <EditableInput
                          name="cbda"
                          placeholder="0.0%"
                          editMode
                          material={false}
                          value={values.cbda || ''}
                          onChange={handleChange}
                          type="number"
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5}>
                        <label className="label-modal"> CBN % </label>
                      </Grid>
                      <Grid item xs={12} sm={7}>
                        <EditableInput
                          name="cbn"
                          placeholder="0.0%"
                          editMode
                          material={false}
                          value={values.cbn || ''}
                          onChange={handleChange}
                          type="number"
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">
                          Apply Cart Discount for Tax Calculation
                        </label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableSelect
                          name="discountable"
                          editMode={true}
                          material={false}
                          value={values.discountable}
                          onChange={handleChange}
                          valueToRender={values.discountable}
                        >
                          {status.map((item, index) => {
                            return (
                              <MenuItem key={index} value={item.value}>
                                {item.label}
                              </MenuItem>
                            )
                          })}
                        </EditableSelect>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">Item Not Eligible for Discount</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableSelect
                          name="discountEnabled"
                          editMode={true}
                          material={false}
                          value={values.discountEnabled}
                          onChange={handleChange}
                          valueToRender={values.discountEnabled}
                        >
                          {discountableStatus.map((item, index) => {
                            return (
                              <MenuItem key={index} value={item.value}>
                                {item.label}
                              </MenuItem>
                            )
                          })}
                        </EditableSelect>
                      </Grid>
                    </Grid>
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <Grid container className="center-aligned-child">
                      <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                        <label className="label-modal">LIT Threshold</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7} lg={7}>
                        <EditableInput
                          name="lowThreshold"
                          placeholder={'Enter LIT Threshold'}
                          editMode={true}
                          material={false}
                          value={values.lowThreshold || ''}
                          onChange={handleChange}
                          valueToRender={values.lowThreshold || ''}
                          disabled={sourceMap.lowThreshold == 'PARENT'}
                        />
                      </Grid>
                    </Grid>
                  </ListItem>
                  {!(sourceMap.assets == 'PARENT') && (
                    <ListItem>
                      <Grid container className="center-aligned-child">
                        <Grid className="labelField" item xs={12} sm={5} md={5} lg={5}>
                          <label className="label-modal">Product Images</label>
                        </Grid>
                        <Grid item xs={12} sm={7} md={7} lg={7}>
                          <br />
                          <Button onClick={this.showMcImageModal} className="button-blue-and-white">
                            Upload
                          </Button>
                        </Grid>
                      </Grid>
                    </ListItem>
                  )}
                </form>
              )
            }}
          </Formik>
        </div>
        <div className="container-form-buttons">
          <Button className="button-white-and-red" onClick={() => this.handleClose(false)}>
            <span className="button-text">Cancel</span>
          </Button>
          <Button
            className="button-blue-and-white"
            variant="contained"
            onClick={this.createMasterProduct}
          >
            <span className="button-text">
              {!product
                ? 'Create Master'
                : this.props.duplicate
                ? 'Duplicate Master'
                : 'Update Product'}
            </span>
          </Button>
        </div>
        {product != null && (
          <ModalConfirmationRemoveLocation
            open={showConfirmationModal}
            close={this.closeConfirmationModal}
            confirmUpdate={() => {
              this.onContinueRegisterHandler(defaultValues)
            }}
            productData={productData}
          />
        )}

        {showModalMcImages && (
          <div>
            <Dialog open={showModalMcImages} className={'container-modal'}>
              <DialogTitle>Images</DialogTitle>
              <DialogContent className={'size-modal'}>
                {product && (
                  <div>
                    <b>Product: </b>
                    <span>{product.name}</span>
                  </div>
                )}
                <br></br>
                {product && product.shop && (
                  <div>
                    <b>Shop: </b>
                    <span>{product.shop.name}</span>
                  </div>
                )}
                <div className="align-title-and-button">
                  <EditableImageUploader
                    editMode={true}
                    valueToRender={null}
                    hideImage={true}
                    imageUploadAPI={this.uploadProductImage}
                  />
                </div>
                <div className="container-scroll-y">
                  <Grid container spacing={2} className="container-product-image">
                    {productImages.length > 0 ? (
                      productImages.map((image, index) => (
                        <Grid key={index} item={4} className="align-item-product-image">
                          <img src={image.largeX2URL} className="product-image" />
                          <Grid className="container-delete-view">
                            <span
                              className="button-remove-image"
                              onClick={() => this.removeImage(image)}
                            >
                              DELETE
                            </span>

                            <span
                              className="view-image-button"
                              onClick={() => this.viewImage(image)}
                            >
                              VIEW
                            </span>
                          </Grid>
                        </Grid>
                      ))
                    ) : (
                      <span>This product has no images</span>
                    )}
                  </Grid>
                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.closeImageModal}>Close</Button>
              </DialogActions>
            </Dialog>
            <Dialog open={openViewImageModal} className={'container-modal'}>
              <DialogContent>
                <img src={selectedImage} className="" />
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleCloseViewImage}>Close</Button>
              </DialogActions>
            </Dialog>
          </div>
        )}
      </div>
    )
  }
}

const FormMasterProductConnected = connect(({ dispatch, shopReducer, masterCatalogReducer }) => ({
  dispatch,
  shopReducer,
  masterCatalogReducer,
}))(FormMasterProduct)

export default FormMasterProductConnected



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/FormMasterProduct.js